// Timers to track inactivity per peer_id
const speakerTimers: Record<string, NodeJS.Timeout> = {};

// Helper to clear timer for a peer
export const clearSpeakerTimer = (peerId: string) => {
  if (speakerTimers[peerId]) {
    clearTimeout(speakerTimers[peerId]);
    delete speakerTimers[peerId];
  }
};

// Helper to start/reset timer for a peer
export const startSpeakerTimer = (peerId: string, resetFn: (peerId: string) => void) => {
  clearSpeakerTimer(peerId);
  speakerTimers[peerId] = setTimeout(() => {
    resetFn(peerId);
    delete speakerTimers[peerId];
  }, 4000);
};
